import { TaskFormObject } from "@timenotes/shared/src/services/tasks/hooks/use-task-formik"
import TagsFilter from "components/timenotes/filters/tags-filter"
import { useFormikContext } from "formik"
import { SidebarButton } from "../sidebar-button"
import { Popover, Tag } from "antd"
import { useEffect, useState } from "react"
import OutsideAlerter from "components/view-utils/outside-alerter"
import { InfoIcon } from "components/base/info-icon"

interface Props {}

export const TaskTagsPopover = (props: Props) => {
  const [visible, setVisible] = useState(false)

  const formik = useFormikContext<TaskFormObject>()
  const task = formik.values

  const tagIds = task.tags?.map((t) => t.id) || []

  useEffect(() => {
    if (visible == false && JSON.stringify(tagIds) !== JSON.stringify(formik.initialValues.tags?.map((t) => t.id) || [])) {
      formik.submitForm()
    }
  }, [visible])

  return (
    <>
      <OutsideAlerter
        onClick={() => setVisible(false)}
      >
        <Popover
          placement="bottom"
          getPopupContainer={(targetNode) => targetNode}
          visible={visible}
          destroyTooltipOnHide

          content={(
            <TagsFilter
              hide={() => setVisible(false)}
              values={tagIds}
              noUpperInput
              onChange={(ids, tags) => {
                formik.setFieldValue('tags', tags)
              }}
            />

          )}
        >
          <div
            onClick={() => {
              setVisible(true)
            }}
          >
            <SidebarButton>
              Tags <InfoIcon
                text="Tags will be automatically configured for every new time log logged in this task. Team members will still have possibility to adjust those during time tracking."
              />
            </SidebarButton>
          </div>
        </Popover>
      </OutsideAlerter>

      <div
        style={{
          maxHeight: '170px',
          marginLeft: '8px',
          overflow: 'scroll',
          cursor: 'pointer',
        }}
        onClick={() => {
          setVisible(true)
        }}
      >
        {(task.tags && task.tags.length > 0) ? task.tags?.map((tag) => (
          <Tag
            style={{
              marginBottom: '5px',
            }}
            color={tag.color}
          >
            {tag.name}
          </Tag>
        )) : (
          <>
            No tags
          </>
        )}
      </div>
    </>
  )
}